<template>
  <model-form
    :model="giftCard"
    modal-type="modal"
    :before-save="saveCard"
  >
    <div>
      <div class="row q-col-gutter-md q-mb-md">
        <q-input
          :model-value="giftCard.uid"
          class="col-12 sensitive-data"
          label="UID"
          readonly
        />
        <q-input
          :model-value="(giftCard.card && giftCard.card.uid)"
          class="col-12 sensitive-data"
          label="Card Barcode"
          clearable
          @update:model-value="value => setCard(giftCard, value)"
        />
        <q-select
          v-model="giftCard.state"
          class="col-12"
          label="State"
          :display-value="$_.startCase(giftCard.state)"
          :options="$mh.asOptions(GIFT_CARD_STATES.OPTIONS)"
          emit-value
        />
        <iso-date-input
          v-model="giftCard.expiresAt"
          class="col-12"
          label="Expires At"
        />
      </div>
    </div>
    <div v-if="giftCard.hasThirdPartyTransactions">
      <q-btn
        label="View Third Party Transactions"
        @click="$refs.thirdPartyTransactionTable.show()"
      />
    </div>

    <third-party-transaction-table
      ref="thirdPartyTransactionTable"
      reward-type="GiftCard"
      :reward-id="giftCard.id"
      :is-dialog="true"
    />
  </model-form>
</template>

<script>
import Card from 'src/models/card/Card'
import { GIFT_CARD_STATES } from 'src/models/gift-card/GiftCard'
import IsoDateInput from 'src/modules/admin/components/IsoDateInput'
import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'
import ThirdPartyTransactionTable from 'src/modules/admin/third-party-reward/ThirdPartyTransactionTable'

export default {
  name: 'GiftCardForm',
  components: {
    IsoDateInput,
    ModelForm,
    ThirdPartyTransactionTable
  },
  models: {
    giftCard: {
      hasThirdPartyTransactions: true,
      recipientUser: {
        id: true,
        firstName: true,
        lastName: true
      },
      card: 'default'
    }
  },
  data () {
    return {
      showThirdPartyTransactionDialog: false
    }
  },
  created () {
    _.extend(this, { GIFT_CARD_STATES })
  },
  methods: {
    async saveCard (model) {
      if ((!model?.card?.uid || model?.card?.uid === '') && !!model?.card?.isRemote) {
        await model.card.delete()
        model.card = null
      }
    },
    setCard (cardable, cardUid) {
      if (!cardable.card) {
        cardable.card = new Card({ uid: cardUid })
      } else {
        cardable.card.uid = cardUid
      }
    }
  }
}

</script>
